const sha256 = async (msg) => {
    const msgBuffer = new TextEncoder().encode(msg)
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("")
    return hashHex
}

const members = async () => {
    const profileImages = Array.from(document.querySelectorAll("[data-member-profile-image]"))
    profileImages.forEach(async (img) => {
        const email = img.getAttribute("data-member-profile-image").trim().toLowerCase()
        const hash = await sha256(email)
        img.src = `https://gravatar.com/avatar/${hash}?s=256&d=initials`
    })
}

export default members
